import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { UiDialog } from 'ui-components';
import { scrollbar } from 'utils';

export const StyledInstagramStoryModal = styled(UiDialog)(
  () => css`
    &.instagram-story-modal {
      .MuiPaper-root {
        border-radius: 8px;
        overflow: hidden;
        max-width: 870px !important;

        .MuiDialogContent-root {
          padding: 32px 24px !important;
        }

        .ui-dialog-content {
          ${scrollbar(0, 0)};
          &:hover {
            ${scrollbar(0, '#9b9ea0')};
          }
        }
      }

      .story {
        display: flex;
        justify-content: space-between;
        gap: 24px;
      }

      .story-image {
        box-sizing: border-box;
        display: flex;
        width: 300px;
        height: 531px;
        box-shadow: 0px 0px 1px 0px rgba(12, 26, 75, 0.24),
          0px 3px 8px -1px rgba(50, 50, 71, 0.05);
        background-color: #111111;
        border-radius: 16px;
        position: relative;

        img,
        video {
          box-sizing: border-box;
          width: 100%;
          max-width: 100%;
          display: block;
          object-fit: contain;
          border-radius: 16px;
          border: 2px solid #aaaaaa;
        }

        .story-image-datetime {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: -27px;
          display: none;
        }
      }

      .story-arrow {
        cursor: pointer !important;
        &::before {
          padding: 2px;
          transition: all 0.3s ease;
        }

        &:hover {
          &::before {
            background-color: #f0f0f0;
            border-radius: 4px;
            padding: 2px;
          }
        }

        &.disabled {
          cursor: default !important;

          &:hover {
            color: #9caebb;

            &::before {
              background-color: unset;
            }
          }
        }
      }

      .story-info {
        box-sizing: border-box;
        overflow-x: hidden;
        overflow-y: auto;
        padding-top: 12px;
        max-height: 531px;
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 16px;
        ${scrollbar(0, 0)};
        &:hover {
          ${scrollbar(0, '#9b9ea0')};
        }

        .story-info-header {
          display: flex;
          justify-content: space-between;
        }

        .story-info-tags {
          display: flex;

          .badge {
            background: unset;
            border: unset;
          }
        }

        .story-info-category {
          display: flex;
          align-items: center;
          gap: 8px;

          .category {
            background-color: #e1e8ff;
            padding: 8px 12px;
            border-radius: 6px;
            color: #6c879b;
            font-size: 0.75rem;
          }
        }

        .story-info-title {
          font-size: 0.87rem;
          font-weight: 700;
          line-height: 1.5rem;
        }

        .story-info-content {
          .story-info-title {
            color: #000;
            margin-bottom: 8px;
          }

          .content {
            color: #333333;
            font-size: 0.87rem;
            font-weight: 700;
            line-height: 1.5rem;
          }
        }

        .story-info-extracted {
          display: flex;
          flex-direction: column;

          .extracted {
            color: #333333;
            font-size: 0.87rem;
            font-weight: 700;
            line-height: 1.5rem;
            text-align: right;
          }
        }

        .story-info-links {
          display: flex;
          flex-direction: column;
          gap: 8px;

          .link {
            color: #4c6fff;
            font-size: 0.75rem;
            font-weight: 700;
            line-height: 1.5rem;
            text-align: right;
            display: flex;
            align-items: center;
            gap: 8px;
            cursor: pointer;

            .icon {
              color: inherit;
              font-weight: 400;
            }
          }
        }
      }

      .story-datetime {
        padding: 4px 0;

        span,
        .icon {
          color: #0f5e62;
          font-weight: 700;
          font-size: 0.75rem;
        }

        .icon {
          font-size: 1rem;
          font-weight: 400;
        }
      }

      .story-user {
        flex: 1;
        padding-left: 24px;
        display: flex;
        gap: 8px;
        overflow: hidden;

        .story-user-info {
          padding: 4px 0;
          flex: 1;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .story-user-name {
            color: #222;
            font-size: 0.87rem;
            font-weight: 700;
            line-height: 2rem;
            display: flex;

            .name {
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              cursor: pointer;
            }
          }

          .story-user-username {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 4px;

            .username {
              color: #777;
              font-size: 0.75rem;
              font-weight: 700;
              line-height: 1.5rem;
              direction: ltr;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              cursor: pointer;
            }

            .icon {
              cursor: pointer;
            }
          }
        }

        .story-user-avatar,
        .story-user-avatar-text {
          min-width: 64px;
          max-width: 64px;
          min-height: 64px;
          max-height: 64px;
          border-radius: 6px;
          border: 1px solid #edf2f7;
          box-shadow: 0px 3px 8px rgba(50, 50, 71, 0.05);
          cursor: pointer;
        }

        .story-user-avatar-text {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .story-close {
        position: absolute;
        top: 0;
        left: 0;
        margin: 12px;
        padding: 12px;
        z-index: 9;
      }

      .story-image-arrow {
        display: none;
      }

      .story-image-wrapper {
        align-self: center;
      }
    }

    @media (max-width: 900px) {
      &.instagram-story-modal {
        .MuiPaper-root {
          width: calc(100% - 32px);
          margin: 16px;
        }

        .story {
          gap: 16px;
        }

        .story-image {
          width: 230px;
          height: 405px;
        }

        .story-info {
          .story-info-header {
            display: flex;
            flex-direction: column;
            gap: 16px;
          }
        }
      }
    }

    @media (max-width: 670px) {
      &.instagram-story-modal {
        .MuiPaper-root {
          border-radius: 8px;
          overflow: hidden;

          .ui-dialog-content {
            overflow-x: hidden;
            overflow-y: auto;

            ${scrollbar(0, 0)};
            &:hover {
              ${scrollbar(0, '#9b9ea0')};
            }
          }
        }

        .story {
          flex-direction: column-reverse;
        }

        .story-info {
          overflow: unset;
        }

        .story-arrow {
          display: none;
        }

        .story-close {
          margin: 0;
        }

        .story-datetime {
          display: none;
        }

        .story-image-wrapper {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 28px;
        }

        .story-image-arrow {
          display: block;
        }

        .story-image {
          .story-image-datetime {
            display: block;
          }
        }
      }
    }

    @media (max-width: 450px) {
      &.instagram-story-modal {
        .MuiPaper-root {
          .MuiDialogContent-root {
            padding: 24px 16px !important;
          }
        }

        .story-image {
          width: 180px;
          height: 317px;
        }
      }
    }
  `
);
